<template>
    <div>
      <div class="pxkeji-right-box">
        <a-form :form="form" @submit="handleSubmit">
          <a-form-item label="网站标题" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入网站标题"
              v-decorator="[
          'title',
          {rules: [{ required: true, message: '请输入网站标题!' }],initialValue:info.title}
        ]"
            ></a-input>
          </a-form-item>

          <a-form-item label="网站关键字" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入网站关键字"
              v-decorator="[
                'keywords',
                {rules: [{ required: true, message: '请输入网站关键字!' }],initialValue:info.keywords}
              ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="网站描述" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入网站描述"
              v-decorator="[
                'description',
                {rules: [{ required: true, message: '请输入网站描述!' }],initialValue:info.description}
              ]"
            ></a-input>
          </a-form-item>
          <a-form-item :wrapper-col="{ span: 19, offset: 5 }" style="margin-top:20px">
            <pxkeji-btn name="保存" type="primary" htmlType="submit" />
          </a-form-item>
        </a-form>
      </div>
     
    </div>

</template>

<script>
var that;
export default {
  props: {
     sourceId:String,
     sourceType:Number
  },
  data() {
    return {
      form: this.$form.createForm(this),
      info: {
        title:"",
        keywords:"",
        description:""
      },
      isloading: false,
      loadingTip: "加载中...",
    };
  },
  components: {
  },
  mounted() {
    console.log('0')
    this.$nextTick(function() {
      console.log('123')
      that = this;
      this.getInfo();
    });
  },
  methods: {
    getInfo() {
      this.isloading = true;
      this.$api.portal
        .getResourceSeo(this.sourceId,this.sourceType)
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            if(res.data){
              this.info = res.data;
            }
            
          } else {
            this.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.isloading = true;
          this.$api.portal
            .setResourceSeo(
              this.sourceId,
              this.sourceType,
              values.title,
              values.keywords,
              values.description
            )
            .then(res => {
              this.isloading = false;
              if (res.errorCode == this.$msg.responseCode.success) {
                this.$message.success(res.errorMsg);
              } else {
                this.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              this.isloading = false;
            });
        }
      });
    }
  }
};
</script>
<style>
</style>